/*
 * Copyright (c) 2021. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by buwaneka on 3/1/2022.
 */

export let PermissionKeys = {
  ENABLE_RECOMMENDATIONS: 'SURF-HOTEL-CRITERIA_ENABLE-RECOMMENDATIONS',
  ENABLE_GEO_SPATIAL_SEARCH: 'SURF-HOTEL-CRITERIA_ENABLE-GEO-SPATIAL-SEARCH'
};

